export default "__VITE_ASSET__D5nyVbUD__"